import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericValidationsService } from 'src/app/Service/generic-validations.service';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';
import { TranslationService } from 'src/app/Service/translation.service';
import { INDIAN_STATES, CONSTANTS } from 'src/Core/Constant';
import { COUNTRY_DIAL_CODES } from 'src/Core/CountryCodes';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-permant-address',
  templateUrl: './permant-address.component.html',
  styleUrls: ['./permant-address.component.scss']
})
export class PermantAddressComponent {

  @Input() applicantData: any; // Accept data from parent component
  @Input() isPreviewMode: boolean = false; // Flag to determine behavior
  @Output() formGroupChange = new EventEmitter<FormGroup>();
  @Output() nextStep = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();
  indianStateOptions = INDIAN_STATES;
  @Input() currentAddressValue: any;
  selectedLanguage: string = 'en'; // Default language 
  countryCodeOptions = COUNTRY_DIAL_CODES;
  residentialAddressForm!: FormGroup;
  submitted = false;
  SaveMode = CONSTANTS.SAVE_MODE
  CONSTANTS = CONSTANTS
  isJsonShow = environment.isJsonShow;  // Set isJsonShow from the environment


  constructor(
    private toastr: ToastrService, 
    private api: SevaProfileService, 
    private fb: FormBuilder, 
    public genericValidations: GenericValidationsService,
    private translationService: TranslationService
  ) { }

  ngOnInit(): void {
    // Load saved language preference
    this.selectedLanguage = this.translationService.getCurrentLanguage();

//     if (!this.isPreviewMode) {
// // Execute only when not in preview mode
//     this.initializeForm();
//     this.getApplicantData();
//   }
}

  // Get translation for current language
  getTranslation(key: string): string {
    return this.translationService.getTranslation(key);
  }



ngOnChanges(changes: SimpleChanges): void {



  if (changes['applicantData'] && this.applicantData) {
    this.initializeForm();
    this.residentialAddressForm.patchValue(this.applicantData.Permanant);
    this.residentialAddressForm.patchValue({"SameAsResidentialAddress" :this.applicantData.SameAsCurrrentAddress});

    this.setMobileValidatorsForCode(this.residentialAddressForm.get('CountryCode')?.value || '+91');

    if (this.isPreviewMode) {
    this.residentialAddressForm.disable();
    }
  }
}



  getApplicantData(){
    this.api.getById('Address/GetAddress?addressTyp', { addressType: CONSTANTS.AddressType.Permanant }).subscribe((response: any) => {
      if (response.Data && Object.keys(response.Data).length > 0) {
        this.genericValidations.setProgressPercentage(response.Data.CompletionPercentage); // Example: Set progress to 50%

        this.residentialAddressForm.patchValue(response.Data);
      }
    })
  }


  initializeForm() {
    this.residentialAddressForm = this.fb.group({
      StreetAddress: ['', Validators.required],
      TownCity: ['', Validators.required],
      District: ['', Validators.required],
      State: ['', Validators.required],
      PinCode: ['', [Validators.required, Validators.pattern(/^[0-9]{6}$/)]],
      CountryCode: ['+91', Validators.required],
      Mobile: ['',],
      WorkPhone: ['',],
      GspId: [''],
      SameAsResidentialAddress:[true, []], 
      Email: ['',],
      AddressType: [CONSTANTS.AddressType.Permanant, [Validators.required]],    //  Personal Address= 1,  //  Emergency Address= 2,
      SaveMode: ['', [Validators.required,]],
    });

    this.setMobileValidatorsForCode(this.residentialAddressForm.get('CountryCode')?.value || '+91');
    this.formGroupChange.emit(this.residentialAddressForm);
  }

  onCountryCodeChange(selection: any): void {
    const code = typeof selection === 'string' ? selection : selection?.code || '';
    this.residentialAddressForm.patchValue({ CountryCode: code });
    this.setMobileValidatorsForCode(code);
  }

  searchCountry = (term: string, item: { code: string; country: string }) => {
    const value = term?.toLowerCase().trim();
    if (!value) return true;
    return (
      item.code.toLowerCase().includes(value) ||
      item.country.toLowerCase().includes(value)
    );
  };

  private setMobileValidatorsForCode(code: string): void {
    const mobileCtrl = this.residentialAddressForm.get('Mobile');

    if (code === '+91') {
      mobileCtrl?.setValidators([
        Validators.required,
        Validators.pattern('^[7-9][0-9]{9}$'),
        Validators.maxLength(10)
      ]);
    } else {
      mobileCtrl?.setValidators([
        Validators.required,
        Validators.pattern('^[0-9]{8,15}$'),
        Validators.maxLength(15)
      ]);
    }

    mobileCtrl?.updateValueAndValidity();
  }

  onSubmit(Mode: number,Parent: string): void {

    this.residentialAddressForm.patchValue({
      SaveMode: Mode
    })

    if (!this.residentialAddressForm.valid && Mode == this.SaveMode.SAVE) {
      this.submitted = true;


        // Add 'submitted' class manually to all invalid controls
    Object.keys(this.residentialAddressForm.controls).forEach((field) => {
      const control = this.residentialAddressForm.get(field);
      if (control && control.invalid) {
        control.markAsTouched(); // Ensure ng-touched is triggered
        const element = document.getElementById(field);
        if (element) {
          element.classList.add('submitted'); // Add 'submitted' class to invalid elements
        }
      }
    });



      return
    }

    const cleanedValues = this.genericValidations.removeWhitespaceFromValues(this.residentialAddressForm.value);
    this.addUpdate(cleanedValues, Mode,Parent);


  }

  addUpdate(reqBoby: any, Mode: number,Parent: string) {
    this.api.apiCall('Address/SaveAddress', 'POST', reqBoby).subscribe((response: any) => {
      console.log('POST response:', response);
      if(Parent == 'CHILD'){
        this.toastr.success( response?.Message);
      }
      if (Mode == this.SaveMode.SAVE) {
        this.nextStep.emit();
      }else if(Mode ==this.SaveMode.DRAFT){
        this.getApplicantData();
      }
    });
  }

  goToBack() {
    this.previous.emit();
  }


  onSameAsResidentialAddressChange(event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;

    this.residentialAddressForm.patchValue({"SameAsResidentialAddress" : isChecked});
    if (isChecked && this.currentAddressValue) {
      this.residentialAddressForm.patchValue(this.currentAddressValue);
    

    this.residentialAddressForm.patchValue({
        AddressType: CONSTANTS.AddressType.Permanant
      });

    } else {
      this.residentialAddressForm.reset({
        AddressType: CONSTANTS.AddressType.Permanant
      });
    }
  }


}


